export enum RecaptchaVersions {
  V2 = 'v2',
  V3 = 'v3',
}
